import _ from 'lodash'
import apiService from 'apiService'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export default function StoresSelect({ handler, width = '12', isMulti = true }) {
    const [stores, setStores] = useState([])

    const getStores = async () => {
        const stores = await apiService.get('/stores/all')
        if (stores === null) return
        stores.map(el => {
            el.label = el.name.toUpperCase()
            el.value = el.id
        })
        setStores(stores)
    }

    const handleChange = e => {
        const storeIds = e.map(el => el.id)
        handler(storeIds)
    }

    useEffect(() => {
        getStores()
    }, [])

    return (
        <>
            <div className={`w-full lg:w-${width} px-4`}>
                <div className="relative w-full mb-3">
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΚΑΤΑΣΤΗΜΑΤΑ</label>
                    <Select options={stores} placeholder="Επιλέξτε καταστήματα" onChange={handleChange} isMulti={isMulti} />
                </div>
            </div>
        </>
    )
}
